import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { addScrollClickTrigger, init as initHashScrolling } from '@project/shared/utils/hashscrolling/js/hashscrolling';

const classes: any = {
	button: 'js-m-stage-product__button'
};

@createModule('StageProduct')
/**
 * Stage Product module implementation.
 */
export class StageProduct extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		initHashScrolling();
		addScrollClickTrigger($(this._ctx).find(`.${classes.button}`));
		resolve();
	}

	stop() {
		// Stop
	}
}
